import { Navigate } from 'react-router-dom';
import { configurationTabPath } from './domain/configurationTabs';
import MainMenu from './pages/MainMenu';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Contracts from './pages/Contracts';
import AddContract from './pages/AddContract';
import Payment from './pages/Payment';
import ClientSheet from './pages/ClientSheet';
import ControlRoom from './pages/ControlRoom';
import Dispozitii from './pages/Dispozitii';
import Statistics from './pages/Statistics';
import Inventory from './pages/Inventory';
import InventoryMovement from './pages/InventoryMovement';
import Metals from './pages/Metals';
import GoodsSale from './pages/GoodsSale';
import Reports from './pages/Reports';
import Rapoarte from './pages/Rapoarte';
import Contabilitate from './pages/Contabilitate';
import Salary from './pages/Salary';
import Registru from './pages/Registru';

import Advanced from './pages/Advanced';
import ConfigurePage from './pages/ConfigurePage';

import CashDrawer from './pages/CashDrawer';
import ChangelogPage from './pages/ChangelogPage';
import Listings from './pages/Listings';
import SessionVerification from './pages/SessionVerification';
import Storno from './pages/Storno';
import HelpCenter from './pages/HelpCenter';
import HardwareServicePage from './pages/HardwareServicePage';
import ChangeUser from './pages/ChangeUser';
import EInvoice from './pages/EInvoice';
import ModuleGuard from './components/ModuleGuard';

export const routes: { path: string; element: JSX.Element }[] = [
    { path: '/', element: <MainMenu /> },
    { path: '/dashboard', element: <Dashboard /> },
    { path: '/clients', element: <Clients /> },
    { path: '/contracts', element: <Contracts /> },
    { path: '/contracts/add', element: <AddContract /> },
    { path: '/contracts/payment', element: <Payment /> },
    { path: '/contracts/client-sheet', element: <ClientSheet /> },
    { path: '/contracte', element: <Contracts /> },
    { path: '/control-room', element: <ControlRoom /> },
    { path: '/dispozitii', element: <Dispozitii /> },
    { path: '/statistics', element: <Statistics /> },
    { path: '/inventory', element: <Inventory /> },
    { path: '/inventory-movement', element: <InventoryMovement /> },
    { path: '/metals', element: <Metals /> },
    { path: '/goods-sale', element: <GoodsSale /> },
    { path: '/reports', element: <Reports /> },
    { path: '/rapoarte', element: <Rapoarte /> },
    { path: '/contabilitate', element: <Contabilitate /> },
    { path: '/salary', element: <Salary /> },
    { path: '/regiszter', element: <Registru /> },
    // The former standalone Settings page now lives in the Configuration page tabs.
    { path: '/settings', element: <Navigate to={configurationTabPath('preferences')} replace /> },

    { path: '/advanced', element: <Advanced /> },
    { path: '/configuration', element: <ConfigurePage /> },
    { path: '/hardware-service', element: <HardwareServicePage /> },

    { path: '/pred_casa', element: <CashDrawer /> },
    { path: '/changelog', element: <ChangelogPage /> },
    { path: '/help', element: <HelpCenter /> },
    { path: '/frmlistari', element: <Listings /> },
    { path: '/frmverifylastsession', element: <SessionVerification /> },
    { path: '/frmstorno', element: <Storno /> },
    // Legacy menu button key `Schutil` ("Schimbare utilizator").
    { path: '/schutil', element: <ChangeUser /> },
    // Separately sold module: the guard shows why it is unavailable instead of the page.
    {
        path: '/e-invoice',
        element: (
            <ModuleGuard moduleKey="e-invoice">
                <EInvoice />
            </ModuleGuard>
        ),
    },
];

export const implementedRouteNames = new Set(
    routes.map(r => r.path.replace(/^\//, '').toLowerCase()).filter(Boolean),
);

export default routes;
